<template lang="pug">
q-dialog(:value="true", @input="onDialogInput")
  q-card.schedule-event-checklist-dialog
    .header
      .text-h6 {{ schedulerLocales.checklist }}
      q-btn(flat, round, dense, :aria-label="schedulerLocales.cancel", v-close-popup)
        inline-svg.close-icon(:src="require('@/assets/icons/form/header/close.svg')")

    .fields(v-show="selectsLoading.length > 0")
      .loader
        q-spinner(color="primary", size="3em")

    .fields(v-show="selectsLoading.length === 0")
      select-field(
        :label="schedulerLocales.checklist",
        full-options-path="/api/v3/checklists",
        :options-params="{ facility_id: facilityId }",
        :initial-value="selectedChecklistId",
        @initial-load="selectLoaded('checklist_id')",
        @change="changeChecklist",
        @reset="changeChecklist(null)"
      )
      checkbox-field(
        :initial-value="required",
        :title="checklistRequiredLabel",
        :disable="!selectedChecklistId",
        @change="required = $event.value"
      )

    .buttons(v-if="selectsLoading.length === 0")
      q-btn.save-button(unelevated, no-caps, :label="schedulerLocales.save", @click="saveChecklist")
</template>

<script setup>
import { computed, ref } from "vue";
import i18n from "@/plugins/vue-i18n";
import { currentLocale } from "@/services/useLocales";
import selectField from "@/components/shared/general_components/fields/selectField.vue";
import checkboxField from "@/components/shared/general_components/fields/checkboxField.vue";

const props = defineProps({
  facilityId: { type: Number, default: null },
  checklistId: { type: [Number, String], default: null },
  checklistRequired: { type: Boolean, default: false },
});

const emit = defineEmits(["close", "save"]);

const selectsLoading = ref(["checklist_id"]);
const selectedChecklistId = ref(props.checklistId);
const required = ref(props.checklistRequired);

const schedulerLocales = computed(() => i18n["messages"][currentLocale.value].scheduler);
const checklistRequiredLabel = computed(() => i18n["messages"][currentLocale.value].checklistRequiredToComplete);

const selectLoaded = name => {
  selectsLoading.value = selectsLoading.value.filter(item => item !== name);
};

const changeChecklist = value => {
  selectedChecklistId.value = value?.value ?? null;

  if (!selectedChecklistId.value) {
    required.value = false;
  }
};

const saveChecklist = () => {
  if (selectsLoading.value.length > 0) {
    return;
  }

  emit("save", {
    checklistId: selectedChecklistId.value,
    checklistRequired: Boolean(selectedChecklistId.value && required.value),
  });
};

const onDialogInput = value => {
  if (!value) {
    emit("close");
  }
};
</script>

<style lang="scss" scoped>
.schedule-event-checklist-dialog {
  --q-color-primary: #5b7aff;

  width: 520px;
  max-width: calc(100vw - 32px);
  padding: 16px;
  color: var(--header-title-color);
  overflow: visible;

  &.q-card {
    border-radius: 12px;
    background: var(--show-card-background);
  }

  .header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 16px;
  }

  .close-icon {
    width: 24px;
    height: 24px;
  }

  .fields {
    margin-top: 32px;
  }

  .loader {
    width: 100%;
    height: 170px;
    display: flex;
    justify-content: center;
    align-items: center;
    margin: auto;
  }

  .checkbox-field {
    margin-top: 20px;
  }

  .buttons {
    display: flex;
    justify-content: center;
    margin-top: 34px;
  }

  .save-button {
    min-width: 150px;
    min-height: 36px;
    padding: 0 30px;
    border-radius: 8px;
    background-color: #5b7aff;
    color: #fff;
    font-size: 14px;
    font-weight: 600;
  }
}
</style>
